import React from "react";
import { QUESTIONS } from "../../constants/testIds";

export default function QuestionProgress({ answered = 0, remaining = 0 }) {
  const total = Math.max(answered + remaining, 1);
  const pct = Math.min(100, Math.round((answered / total) * 100));
  return (
    <div data-testid={QUESTIONS.progress} className="mb-8 card-panel p-4 border-l-4 border-l-[hsl(var(--brand-red))]">
      <div className="flex items-center justify-between text-xs text-neutral-500 mb-3">
        <span className="uppercase tracking-[0.2em] font-semibold text-[hsl(var(--brand-navy))]">
          Almost there
        </span>
        <span className="font-mono tabular-nums text-[hsl(var(--brand-red))]">{pct}%</span>
      </div>
      <div className="h-1.5 w-full bg-neutral-100 rounded-full overflow-hidden">
        <div
          className="h-full rounded-full bg-gradient-to-r from-[hsl(var(--brand-navy))] to-[hsl(var(--brand-red))] transition-[width] duration-500 ease-out"
          style={{ width: `${Math.max(pct, 6)}%` }}
        />
      </div>
      <p className="mt-2 text-xs text-neutral-400">
        {remaining > 0
          ? `${remaining} detail${remaining === 1 ? "" : "s"} remaining`
          : "Finalizing your request"}
      </p>
    </div>
  );
}
